module.exports = __webpack_public_path__ + "45d8549ff37619d371034e7ef68b16e2.svg";